export default __webpack_public_path__ + "static/media/Transfer_certificate_2.bbeb5cc6.svg";